module.exports = __webpack_public_path__ + "static/media/back_happy.6cd06a4a.png";